import { render } from "./LetterSignature.vue?vue&type=template&id=0a74f856"
import script from "./LetterSignature.vue?vue&type=script&lang=js"
export * from "./LetterSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__